let currency = {
  install: function (Vue) {
    Vue.prototype.__axios = (url, params,handle) => {
      let href = window.location.href;
      Object.assign(params, {test: href.indexOf('zidouchat') === -1, token: sessionStorage.token});
      Vue.prototype.axios.post(url, params).then(res => {
        if (res.data.status === 200) {
          handle(res)
        } else if (res.data.status === 403) {
          window.location.hash = '#/login'
        } else {
          Vue.prototype.$message({
            message: res.data.data.code,
            type: 'error'
          })
        }
      }).catch(err => {
          if (err) {Vue.prototype.$message({
            message: err,
            type: 'error'
          })
        }
      })
    };
    Vue.prototype.__confirm = (info, act, params) => {
      Vue.prototype.$confirm(info, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        act(...params)
      }).catch()
    };
    Vue.prototype.getDomain = function () {
      if (window.location.href.indexOf('localhost') !== -1) {
        return 'http://localhost:3000/'
      } else if (window.location.href.indexOf('zidouchat') !== -1) {
        return 'http://api.blog.zidouchat.com:20081/'
      } else {
        return 'http://api.blog.zidouzone.com:10081/'
      }
    }
  }
};

export default currency
